// Data Store - manages application state with localStorage persistence

export interface Customer {
  id: string;
  kodPelanggan: string;
  namaSyarikat: string;
  email: string;
  telp: string;
  alamat: string;
  status: 'Aktif' | 'Nonaktif';
}

export interface Quote {
  id: string;
  no: string;
  pelanggan: string;
  namaProyek?: string;
  jumlah: number;
  tanggal: string;
  total?: number;
  status: 'Draft' | 'Diterima' | 'Menunggu' | 'Ditolak';
  catatan?: string;
}

export interface SiteVisit {
  id: string;
  no: string;
  projek: string;
  pelanggan: string;
  lokasi: string;
  tarikh: string;
  masa?: string;
  petugas: string;
  tujuanKunjungan: string;
  daerah?: string;
  alamatLokasi?: string;
  kontak?: string;
  catatan?: string;
  status: 'Draf' | 'Selesai' | 'Menunggu';
}

export interface InvoiceItem {
  id: string;
  no: string;
  pelanggan: string;
  tanggal: string;
  total: number;
  bayar: number;
  status: 'Lunas' | 'Sebagian' | 'Belum';
}

export interface Project {
  id: string;
  kodProjek: string;
  namaProjek: string;
  pelanggan: string;
  nilaiProjek: number;
  kosProjek: number;
  status: 'Dalam Proses' | 'Selesai' | 'Tender' | 'Dibatalkan';
  tarikhMula: string;
  tarikhSiap: string;
  catatan?: string;
}

export interface Cost {
  id: string;
  kodKos: string;
  projek: string;
  kategori: string;
  penerangan: string;
  kuantiti: number;
  unit: string;
  hargaPerUnit: number;
  jumlah: number;
  tarikh: string;
  catatan?: string;
}

export interface Report {
  id: string;
  nomorLaporan: string;
  projek: string;
  jenis: string;
  tarikhMula: string;
  tarikhAkhir: string;
  oleh: string;
  kandungan: string;
  status: 'Draf' | 'Selesai' | 'Disetujui';
}

export interface ProjectImage {
  id: string;
  kodGambar: string;
  kodProjek: string;
  projek: string;
  tarikh: string;
  keterangan: string;
  file: string;
  fileName: string;
  fileType: 'image' | 'video';
}

// Default empty data
const DEFAULT_DATA = {
  customers: [] as Customer[],
  quotes: [] as Quote[],
  siteVisits: [] as SiteVisit[],
  projects: [] as Project[],
  costs: [] as Cost[],
  invoices: [] as InvoiceItem[],
  reports: [] as Report[],
  projectImages: [] as ProjectImage[],
  debts: [] as any[],
};

const STORAGE_KEY = 'sap_ngecat_data';

export const DataStore = {
  getData: () => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : DEFAULT_DATA;
  },

  saveData: (data: typeof DEFAULT_DATA) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },

  reset: () => {
    localStorage.removeItem(STORAGE_KEY);
  },
};